/* ------------------------------------------------------------------ */
/*  UI & Branding                                                     */
/* ------------------------------------------------------------------ */
export const BREAKPOINTS = {
  XS: 0,
  SM: 600,
  MD: 960,  // Sidebar permanent breakpoint
  LG: 1280,
  XL: 1920,
};

export const BRAND_COLORS = {
  PRIMARY: '#3fbb85',
  LIGHT:   '#5cc596',
  DARK:    '#309865',
};

export const QUICK_FILTERS = [
  { value: 'Today',   label: 'Today'   },
  { value: 'Weekly',  label: 'Weekly'  },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Yearly',  label: 'Yearly'  },
];

/* ------------------------------------------------------------------ */
/*  User Roles  (kept in-sync with backend enum)                      */
/* ------------------------------------------------------------------ */
export const USER_ROLES = {
  PRESENTER:       'Presenter',
  INFLUENCER:      'Influencer',
  STATION_MANAGER: 'StationManager',
  ADMIN:           'Admin',
  ADMIN_VIEW:      'AdminView',
  NLA_ADMIN:       'NLAADMIN',
  SUPER_ADMIN:     'SuperAdmin',
};

/* ------------------------------------------------------------------ */
/*  Route Definitions                                                 */
/* ------------------------------------------------------------------ */
export const ROUTES = {
  // Auth
  LOGIN:     '/login',
  REGISTER:  '/register',

  // Common
  DASHBOARD: '/dashboard',
  PROFILE:   '/profile',
  REFERRAL:  '/referral',
  JACKPOT:   '/jackpot',

  // Business / Analytics
  PRODUCTS:     '/products',
  CUSTOMERS:    '/customers',
  DEPOSITS:     '/deposits',
  WITHDRAWALS:  '/withdrawals',
  GAMES:        '/games',

  // Admin
  USERS:          '/users',
  RETENTION:      '/retention',
  POINTS:         '/points',
  REFERRAL_ANALYTICS: '/referral-analytics',
  DEPOSIT_RECONCILE: '/deposit-reconcile',
  ADMIN_SETTINGS: '/admin/settings',

  // NLA Admin
  NLA_ADMIN_DASHBOARD: '/nla-admin/dashboard',
  NLA_ADMIN_CONFIG:    '/nla-admin/system-config',

  // Errors
  UNAUTHORIZED: '/unauthorized',
  NOT_FOUND:    '/404',
};

/* ------------------------------------------------------------------ */
/*  Role-based route permissions (single source of truth)             */
/* ------------------------------------------------------------------ */
export const ROUTE_PERMISSIONS = {
  /*  Influencer sees revenue (deposits) + leaderboards (customers)  */
  [USER_ROLES.INFLUENCER]: [
    ROUTES.DASHBOARD,
    ROUTES.PROFILE,
    ROUTES.REFERRAL,
    // ROUTES.PRODUCTS,
    // ROUTES.CUSTOMERS,
    // ROUTES.DEPOSITS,
  ],

  /*  Station Manager can review staff, customers & revenue         */
  [USER_ROLES.STATION_MANAGER]: [
    ROUTES.DASHBOARD,
    ROUTES.PROFILE,
    ///ROUTES.USERS,
    ROUTES.REFERRAL,
    //ROUTES.CUSTOMERS,
   
  ],

  /*  NLA Admin has its own narrow console                           */
  [USER_ROLES.NLA_ADMIN]: [
    ROUTES.DASHBOARD,
    ROUTES.NLA_ADMIN_DASHBOARD,
    ROUTES.NLA_ADMIN_CONFIG,
  ],

  /*  Presenter has the leanest view                                 */
  [USER_ROLES.PRESENTER]: [
    ROUTES.DASHBOARD,
    ROUTES.PROFILE,
  ],

  /*  Admin sees all except super-admin-only pages.
      User Management is included so Admin can add non-admin users. */
  [USER_ROLES.ADMIN]: Object.values(ROUTES).filter(
    (route) =>
      ![
        ROUTES.RETENTION,
        ROUTES.POINTS,
        ROUTES.JACKPOT,
        ROUTES.REFERRAL_ANALYTICS,
        ROUTES.DEPOSIT_RECONCILE,
        ROUTES.ADMIN_SETTINGS,
      ].includes(route)
  ),

  /*  AdminView sees the same core ops pages as Admin, view-only set  */
  [USER_ROLES.ADMIN_VIEW]: [
    ROUTES.DASHBOARD,
    ROUTES.PROFILE,
    ROUTES.PRODUCTS,
    ROUTES.DEPOSITS,
    ROUTES.WITHDRAWALS,
    ROUTES.GAMES,
  ],

  /*  Super Admin has full access                                     */
  [USER_ROLES.SUPER_ADMIN]: Object.values(ROUTES),
};

/* ------------------------------------------------------------------ */
/*  API endpoints & storage keys                                      */
/* ------------------------------------------------------------------ */
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN:    '/dashboarduser/login',
    REGISTER: '/dashboarduser/register',
    REFRESH:  '/dashboarduser/refresh',
    PROFILE:  '/dashboarduser/profile',
    LOGOUT:   '/dashboarduser/logout',
  },
};

export const STORAGE_KEYS = {
  TOKEN:         'token',
  REFRESH_TOKEN: 'refreshToken',
  USER_ROLE:     'role',
  USER_DATA:     'userData',
};

/* ------------------------------------------------------------------ */
/*  UI constants                                                      */
/* ------------------------------------------------------------------ */
export const UI_CONSTANTS = {
  DRAWER_WIDTH:           240,
  HEADER_HEIGHT:          64,
  LOADING_DELAY:          300,
  ERROR_DISPLAY_DURATION: 5000,
};


// // src/utils/constants.js

// // --- UI & Branding ---
// export const BREAKPOINTS = {
//   XS: 0,
//   SM: 600,
//   MD: 960, // Sidebar permanent breakpoint
//   LG: 1280,
//   XL: 1920,
// };

// export const BRAND_COLORS = {
//   PRIMARY: '#3fbb85',
//   LIGHT: '#5cc596',
//   DARK: '#309865',
// };

// export const QUICK_FILTERS = [
//   { value: 'Today', label: 'Today' },
//   { value: 'Weekly', label: 'Weekly' },
//   { value: 'Monthly', label: 'Monthly' },
//   { value: 'Yearly', label: 'Yearly' },
// ];

// // --- User Roles ---
// // --- User Roles ---
// // FIX: Aligned roles with the backend Mongoose schema enum
// export const USER_ROLES = {
//   PRESENTER: 'Presenter', // Was 'Journalist'
//   INFLUENCER: 'Influencer',
//   STATION_MANAGER: 'StationManager',
//   ADMIN: 'Admin',
//   NLA_ADMIN: 'NLAADMIN', // Was 'NLAAdmin'
// };


// // --- Route Definitions ---
// export const ROUTES = {
//   // Auth
//   LOGIN: '/login',
//   REGISTER: '/register',

//   // Common
//   DASHBOARD: '/dashboard',
//   PROFILE: '/profile',

//   // Business
//   PRODUCTS: '/products',
//   CUSTOMERS: '/customers',
//   DEPOSITS: '/deposits',
//   WITHDRAWALS: '/withdrawals',
//   GAMES: '/games',

//   // Admin
//   USERS: '/users',
//   ADMIN_DASHBOARD: '/dashboard',
//   ADMIN_SETTINGS: '/admin/settings',

//   // NLA Admin
//   NLA_ADMIN_DASHBOARD: '/nla-admin/dashboard',
//   NLA_ADMIN_CONFIG: '/nla-admin/system-config',

//   // Errors
//   UNAUTHORIZED: '/unauthorized',
//   NOT_FOUND: '/404',
// };

// // --- Role-Based Route Permissions (Single Source of Truth) ---
// export const ROUTE_PERMISSIONS = {
//   [USER_ROLES.JOURNALIST]: [
//     ROUTES.DASHBOARD,
//     ROUTES.PROFILE,
//     ROUTES.PRODUCTS,
//     ROUTES.CUSTOMERS,
//   ],
//   [USER_ROLES.INFLUENCER]: [
//     ROUTES.DASHBOARD,
//     ROUTES.PROFILE,
//     ROUTES.PRODUCTS,
//     ROUTES.CUSTOMERS,
//   ],
//   [USER_ROLES.STATION_MANAGER]: [
//     ROUTES.DASHBOARD,
//     ROUTES.PROFILE,
//     ROUTES.USERS,
//   ],
//   [USER_ROLES.NLA_ADMIN]: [
//     // Example: NLA Admin might have a more restricted view
//     ROUTES.DASHBOARD,
//     ROUTES.NLA_ADMIN_DASHBOARD,
//     ROUTES.NLA_ADMIN_CONFIG,
//   ],
//   // Admin has access to all defined routes
//   [USER_ROLES.ADMIN]: Object.values(ROUTES),
// };

// // --- API & Storage ---
// export const API_ENDPOINTS = {
//   AUTH: {
//     LOGIN: '/dashboarduser/login',
//     REGISTER: '/dashboarduser/register',
//     REFRESH: '/dashboarduser/refresh',
//     PROFILE: '/dashboarduser/profile',
//     LOGOUT: '/dashboarduser/logout',
//   },
// };

// export const STORAGE_KEYS = {
//   TOKEN: 'token',
//   REFRESH_TOKEN: 'refreshToken',
//   USER_ROLE: 'role',
//   USER_DATA: 'userData',
// };

// // --- UI Constants ---
// export const UI_CONSTANTS = {
//   DRAWER_WIDTH: 240,
//   HEADER_HEIGHT: 64,
//   LOADING_DELAY: 300,
//   ERROR_DISPLAY_DURATION: 5000,
// };

// export const BREAKPOINTS = {
//   XS: 0,
//   SM: 600,
//   MD: 960, // Sidebar permanent breakpoint
//   LG: 1280,
//   XL: 1920,
// };

// export const BRAND_COLORS = {
//   PRIMARY: '#3fbb85',
//   LIGHT: '#5cc596',
//   DARK: '#309865',
// };

// export const QUICK_FILTERS = [
//   { value: 'Today', label: 'Today' },
//   { value: 'Weekly', label: 'Weekly' },
//   { value: 'Monthly', label: 'Monthly' },
//   { value: 'Yearly', label: 'Yearly' },
// ];





// // src/utils/constants.js
// export const ROUTES = {
//   // Auth routes
//   LOGIN: '/login',
//   REGISTER: '/register',
  
//   // Main routes
//   DASHBOARD: '/dashboard',
//   PROFILE: '/profile',
  
//   // Business routes
//   PRODUCTS: '/products',
//   CUSTOMERS: '/customers',
//   DEPOSITS: '/deposits',
//   WITHDRAWALS: '/withdrawals',
//   GAMES: '/games',
  
//   // Admin routes
//   USERS: '/users',
//   ADMIN_DASHBOARD: '/admin/dashboard',
//   ADMIN_SETTINGS: '/admin/settings',
  
//   // NLA Admin routes
//   NLA_ADMIN_DASHBOARD: '/nla-admin/dashboard',
//   NLA_ADMIN_CONFIG: '/nla-admin/system-config',
  
//   // Error routes
//   UNAUTHORIZED: '/unauthorized',
//   NOT_FOUND: '/404',
// };

// // Role-based route access mapping
// export const ROUTE_PERMISSIONS = {
//   // Public routes (no auth required)
//   PUBLIC: [ROUTES.LOGIN, ROUTES.REGISTER],
  
//   // Routes accessible to all authenticated users
//   AUTHENTICATED: [ROUTES.DASHBOARD, ROUTES.PROFILE],
  
//   // Routes for content creators (Journalist, Influencer, and above)
//   CONTENT_CREATORS: [
//     ROUTES.PRODUCTS,
//     ROUTES.CUSTOMERS,
//   ],
  
//   // Routes for managers (StationManager and above)
//   MANAGERS: [
//     ROUTES.DEPOSITS,
//     ROUTES.WITHDRAWALS,
//     ROUTES.GAMES,
//   ],
  
//   // Routes for admins only
//   ADMIN_ONLY: [
//     ROUTES.USERS,
//     ROUTES.ADMIN_DASHBOARD,
//     ROUTES.ADMIN_SETTINGS,
//   ],
  
//   // Routes for NLA admins only
//   NLA_ADMIN_ONLY: [
//     ROUTES.NLA_ADMIN_DASHBOARD,
//     ROUTES.NLA_ADMIN_CONFIG,
//   ],
// };

// // User roles
// export const USER_ROLES = {
//   JOURNALIST: 'Journalist',
//   STATION_MANAGER: 'StationManager',
//   ADMIN: 'Admin',
//   INFLUENCER: 'Influencer',
//   NLA_ADMIN: 'NLAADMIN',
// };

// // Role hierarchy levels (higher number = more permissions)
// export const ROLE_LEVELS = {
//   [USER_ROLES.JOURNALIST]: 1,
//   [USER_ROLES.INFLUENCER]: 2,
//   [USER_ROLES.STATION_MANAGER]: 3,
//   [USER_ROLES.ADMIN]: 4,
//   [USER_ROLES.NLA_ADMIN]: 5,
// };

// // API endpoints
// export const API_ENDPOINTS = {
//   AUTH: {
//     LOGIN: '/dashboarduser/login',
//     REGISTER: '/dashboarduser/register',
//     REFRESH: '/dashboarduser/refresh',
//     PROFILE: '/dashboarduser/profile',
//     LOGOUT: '/dashboarduser/logout',
//   },
//   // Add other API endpoints as needed
// };

// // Local storage keys
// export const STORAGE_KEYS = {
//   TOKEN: 'token',
//   REFRESH_TOKEN: 'refreshToken',
//   USER_ROLE: 'role',
//   USER_DATA: 'userData',
// };

// // UI Constants
// export const UI_CONSTANTS = {
//   DRAWER_WIDTH: 240,
//   HEADER_HEIGHT: 64,
//   LOADING_DELAY: 300,
//   ERROR_DISPLAY_DURATION: 5000,
// };

// export default {
//   ROUTES,
//   ROUTE_PERMISSIONS,
//   USER_ROLES,
//   ROLE_LEVELS,
//   API_ENDPOINTS,
//   STORAGE_KEYS,
//   UI_CONSTANTS,
// };